import { TransactionsList } from "../components/TransactionsList.tsx";
import { Page } from "@ui/page/Page";
import { useCallback, useEffect, useState } from "react";

export const TransactionsPage = () => {
	const [cardId, setCardId] = useState<string | undefined>(undefined);
	// Read once: team analytics links here with a team and its chart period.
	const [{ teamId, days, status, type }] = useState(() => {
		const searchParams = new URLSearchParams(window.location.search);
		return {
			teamId: searchParams.get("teamId") || undefined,
			days: Number(searchParams.get("days")) || undefined,
			status: searchParams.get("status") || undefined,
			type: searchParams.get("type") || undefined,
		};
	});

	useEffect(() => {
		const updateCardId = () => {
			const searchParams = new URLSearchParams(window.location.search);
			const cid = searchParams.get("cardId") || undefined;
			setCardId(prev => (prev !== cid ? cid : prev));
		};

		updateCardId();
		window.addEventListener("locationchange", updateCardId);
		return () => window.removeEventListener("locationchange", updateCardId);
	}, []);

	const handleCardIdChange = useCallback((nextCardId?: string) => {
		const searchParams = new URLSearchParams(window.location.search);

		if (nextCardId) {
			searchParams.set("cardId", nextCardId);
		} else {
			searchParams.delete("cardId");
		}

		const nextSearch = searchParams.toString();
		const nextUrl = `/transactions${nextSearch ? `?${nextSearch}` : ""}`;

		if (window.location.pathname + window.location.search === nextUrl) return;

		history.replaceState({}, "", nextUrl);
	}, []);

	return (
		<Page
			label="Transactions"
			description="Find, check or export company transactions."
			sx={{ boxShadow: "none", paddingTop: "24px" }}
		>
			<TransactionsList source="global" initialCardUid={cardId} initialTeamUid={teamId} initialLookbackDays={days} initialStatus={status} initialTxType={type} onCardIdChange={handleCardIdChange} />
		</Page>
	);
};
